import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {ScheduleAgreementsByVendor} from '../types'

export const ScheduleAgreementsByVendorQueryKey = 'scheduleAgreementsByVendor'

type Params<TSelect = ScheduleAgreementsByVendor[]> = {
  plantCode: string
  materialId: number
  options?: Omit<
    UseQueryOptions<ScheduleAgreementsByVendor[], AxiosError, TSelect>,
    'queryKey' | 'queryFn'
  >
}

export const useScheduleAgreementsByVendorQuery = <TSelect = ScheduleAgreementsByVendor[]>({
  plantCode,
  materialId,
  options
}: Params<TSelect>) =>
  useQuery<ScheduleAgreementsByVendor[], AxiosError, TSelect>({
    queryKey: [ScheduleAgreementsByVendorQueryKey, plantCode, materialId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ScheduleAgreementsByVendor[]>(
        `/plants/${plantCode}/materials/${materialId}/schedule-agreements`,
        {signal}
      )
      return response.data
    },
    ...options
  })
